import { ActionTree } from 'vuex';
import router from '@/router';
import { clearToken, deleteCurrentLoggedInUser, saveToken } from '@/features/auth/helpers';
import { TokenData, Auth } from '@/features/auth/types';
import { isLocalhost } from '@/features/common/helpers';
import { saveTokenOnLegacySite } from '../services/auth.services';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<Auth, any> = {
  async signIn(
    { dispatch, commit },
    { tokenData, redirectTo }: { tokenData: TokenData, redirectTo: string },
  ) {
    saveToken(tokenData);

    if (isLocalhost()) {
      commit('setIsAuth', true);
      dispatch('initFetch');

      const finalRedirectTo = redirectTo || '/dashboard';

      if (window.location.pathname !== finalRedirectTo) {
        router.push(finalRedirectTo).catch(() => null);
      }

      return;
    }

    await saveTokenOnLegacySite(tokenData);

    let url = '/webship/v2logincheck.aspx';
    if (redirectTo) {
      const routeInfo = router.resolve(redirectTo);
      const finalRedirectTo = routeInfo.href || '/dashboard';
      url += `?return_url=${finalRedirectTo}`;
    }

    window.location.assign(url);
  },

  logout(state) {
    clearToken();
    deleteCurrentLoggedInUser();
    state.commit('setIsAuth', false);
  },
};

export default actions;
